export const GET_DEVICE_TYPES_REQUEST = 'GET_DEVICE_TYPES_REQUEST';
export const GET_DEVICE_TYPES_SUCCESS = 'GET_DEVICE_TYPES_SUCCESS';
export const GET_DEVICE_TYPES_FAILURE = 'GET_DEVICE_TYPES_FAILURE';
export const GET_DEVICE_TYPES_TIMEOUT = 'GET_DEVICE_TYPES_TIMEOUT';

export const GET_REPLACEMENT_BY_DEVICE_TYPE_REQUEST = 'GET_REPLACEMENT_BY_DEVICE_TYPE_REQUEST';
export const GET_REPLACEMENT_BY_DEVICE_TYPE_SUCCESS = 'GET_REPLACEMENT_BY_DEVICE_TYPE_SUCCESS';
export const GET_REPLACEMENT_BY_DEVICE_TYPE_FAILURE = 'GET_REPLACEMENT_BY_DEVICE_TYPE_FAILURE';
export const GET_REPLACEMENT_BY_DEVICE_TYPE_TIMEOUT = 'GET_REPLACEMENT_BY_DEVICE_TYPE_TIMEOUT';

export const  CLEAR_MESSAGE = 'CLEAR_MESSAGE';


export const POST_CONFIRM_REPLACEMENT_REQUEST="POST_CONFIRM_REPLACEMENT_REQUEST";
export const POST_CONFIRM_REPLACEMENT_SUCCESS="POST_CONFIRM_REPLACEMENT_SUCCESS";
export const POST_CONFIRM_REPLACEMENT_FAILURE="POST_CONFIRM_REPLACEMENT_FAILURE";
export const POST_CONFIRM_REPLACEMENT_TIMEOUT="POST_CONFIRM_REPLACEMENT_TIMEOUT";



export const GET_RMA_STATUS_REQUEST = "GET_RMA_STATUS_REQUEST";
export const GET_RMA_STATUS_SUCCESS = "GET_RMA_STATUS_SUCCESS";
export const GET_RMA_STATUS_FAILURE = "GET_RMA_STATUS_FAILURE";
export const GET_RMA_STATUS_TIMEOUT = "GET_RMA_STATUS_TIMEOUT";


export const TRANSIENT_STATUSES = ["DEVICE_REPLACEMENT_IN_PROGRESS","INITIATING_REPLACEMENT_LOADER","FETCHING_DEVICE_DETAILS_LOADER","IN_PROGRESS"];